module.exports = __webpack_public_path__ + "static/media/11.b53a7dac.svg";